import React, { useState, useEffect } from 'react';
import veggieIcon from '../../Images/veggie-favicon.png';

export default function HospitalLoader() {
  const [progress, setProgress] = useState(0);
  
  // Total loading time in milliseconds (adjust as needed)
  const TOTAL_LOADING_TIME = 5000; // 5 seconds
  const UPDATE_INTERVAL = 50; // Update every 50ms for smooth animation
  const INCREMENT = (100 / (TOTAL_LOADING_TIME / UPDATE_INTERVAL)); // Calculate increment per update

  useEffect(() => {
    const interval = setInterval(() => {
      setProgress(prev => {
        if (prev >= 100) {
          clearInterval(interval);
          return 100;
        }
        return Math.min(prev + INCREMENT, 100); // Ensure it doesn't exceed 100
      });
    }, UPDATE_INTERVAL);

    return () => clearInterval(interval);
  }, []);

  return (
    <div className="loader-wrapper">
      <div className="loader-container">
        {/* Medical Logo Container */}
        <div className="medical-logo">
          <div className="cross-container">
            {/* Replace this src with your actual logo URL */}
            <img 
              src={veggieIcon} 
              alt="Azm Rehab Centre Logo" 
              className="logo-image"
              onError={(e) => {
                // Show fallback cross if image fails to load
                e.target.style.display = 'none';
                e.target.parentNode.querySelector('.cross-vertical').style.display = 'block';
                e.target.parentNode.querySelector('.cross-horizontal').style.display = 'block';
              }}
            />
            {/* <div className="cross-vertical"></div>
            <div className="cross-horizontal"></div> */}
          </div>
          <div className="pulse-ring"></div>
        </div>

        {/* Hospital Name */}
        <h2 className="hospital-name">Azm Rehab Centre</h2>
        
        {/* Progress Bar */}
        {/* <div className="progress-container">
          <div className="progress-bar">
            <div 
              className="progress-fill" 
              style={{ width: `${progress}%` }}
            ></div>
          </div>
        </div> */}

        {/* Animated Loading Dots */}
        <div className="loading-animation">
          <div className="loading-dots">
            <div className="dot"></div>
            <div className="dot"></div>
            <div className="dot"></div>
            <div className="dot"></div>
            <div className="dot"></div>
          </div>
          <div className="loading-text">Please wait</div>
        </div>
      </div>

      <style jsx>{`
         .logo-image {
           margin-top: -15px;
    margin-left: 3px;
    width: 152%;
    height: 148%;
          }
        .loader-wrapper {
          height: 100vh;
          display: flex;
          justify-content: center;
          align-items: center;
          background-color: #f8fafc;
          font-family: 'Arial', sans-serif;
        }

        .loader-container {
          text-align: center;
          max-width: 300px;
        }

        .medical-logo {
          position: relative;
          margin-bottom: 30px;
        }

        .cross-container {
          width: 80px;
          height: 80px;
          margin: 0 auto;
          position: relative;
          background: white;
          border-radius: 50%;
          box-shadow: 0 8px 30px rgba(0, 0, 0, 0.2);
          display: flex;
          align-items: center;
          justify-content: center;
        }

        .cross-vertical {
          width: 6px;
          height: 30px;
          background: #dc2626;
          border-radius: 3px;
          position: absolute;
        }

        .cross-horizontal {
          width: 30px;
          height: 6px;
          background: #dc2626;
          border-radius: 3px;
          position: absolute;
        }

        .pulse-ring {
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          width: 80px;
          height: 80px;
          border: 2px solid rgba(220, 38, 38, 0.6);
          border-radius: 50%;
          opacity: 0;
          animation: pulse 2s ease-out infinite;
        }

        .hospital-name {
          color: #334155;
          font-size: 24px;
          font-weight: 600;
          margin: 0 0 30px 0;
          letter-spacing: 0.5px;
          text-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
        }

        .progress-container {
          width: 100%;
          margin-bottom: 30px;
        }

        .progress-bar {
          width: 100%;
          height: 4px;
          background: rgba(148, 163, 184, 0.3);
          border-radius: 2px;
          overflow: hidden;
        }

        .progress-fill {
          height: 100%;
          background: linear-gradient(90deg, #dc2626, #ef4444);
          border-radius: 2px;
          transition: width 0.1s ease;
        }

        .loading-animation {
          display: flex;
          flex-direction: column;
          align-items: center;
          gap: 15px;
        }

        .loading-dots {
          display: flex;
          gap: 8px;
          align-items: center;
        }

        .dot {
          width: 8px;
          height: 8px;
          background: #dc2626;
          border-radius: 50%;
          animation: bounce 1.4s ease-in-out infinite both;
        }

        .dot:nth-child(1) { animation-delay: -0.32s; }
        .dot:nth-child(2) { animation-delay: -0.16s; }
        .dot:nth-child(3) { animation-delay: 0s; }
        .dot:nth-child(4) { animation-delay: 0.16s; }
        .dot:nth-child(5) { animation-delay: 0.32s; }

        .loading-text {
          color: #64748b;
          font-size: 14px;
          font-weight: 500;
          letter-spacing: 1px;
        }

        @keyframes pulse {
          0% {
            transform: translate(-50%, -50%) scale(1);
            opacity: 0.7;
          }
          100% {
            transform: translate(-50%, -50%) scale(1.3);
            opacity: 0;
          }
        }

        @keyframes bounce {
          0%, 80%, 100% {
            transform: scale(0.8);
            opacity: 0.5;
          }
          40% {
            transform: scale(1.2);
            opacity: 1;
          }
        }

        /* Mobile responsive */
        @media (max-width: 480px) {
          .cross-container {
            width: 70px;
            height: 70px;
          }
          
          .pulse-ring {
            width: 70px;
            height: 70px;
          }
          
          .hospital-name {
            font-size: 20px;
          }
          
          .loader-container {
            max-width: 280px;
          }
          
          .logo-image {
            width: 100%;
            height: 100%;
          }
        }
      `}</style>
    </div>
  );
}